<nb-card class="form">
  <nb-card-header>
    <h4>{{ "dialogs.moodlePush.title" | translate }}</h4>
    <p class="course-label">{{ courseName }}</p>
  </nb-card-header>

  <nb-card-body>
    <!-- Loading categories -->
    <div *ngIf="loading" class="loading-state">
      <nb-spinner status="primary" size="medium"></nb-spinner>
      <p>{{ "dialogs.moodlePush.loadingCategories" | translate }}</p>
    </div>

    <!-- Push form -->
    <div *ngIf="!loading && !pushing && !pushResult">
      <div class="form-group" *ngIf="sites.length > 1">
        <label>{{ "dialogs.moodlePush.targetSite" | translate }}</label>
        <nb-select
          [selected]="selectedRegistrationId"
          (selectedChange)="onSiteChange($event)"
          placeholder="{{ 'dialogs.moodlePush.targetSitePlaceholder' | translate }}"
          fullWidth
        >
          <nb-option *ngFor="let site of sites" [value]="site.id">
            {{ site.display_name || site.moodle_site_url }}
            <span *ngIf="site.is_primary"> — {{ "dialogs.moodlePush.primaryBadge" | translate }}</span>
          </nb-option>
        </nb-select>
        <p class="hint">{{ "dialogs.moodlePush.targetSiteHint" | translate }}</p>
      </div>

      <div class="form-group">
        <label>{{ "dialogs.moodlePush.category" | translate }}</label>
        <nb-select
          [(selected)]="selectedCategoryId"
          placeholder="{{ 'dialogs.moodlePush.categoryPlaceholder' | translate }}"
          fullWidth
        >
          <nb-option *ngFor="let cat of categories" [value]="cat.id">
            {{ cat.name }}
          </nb-option>
        </nb-select>
      </div>

      <div class="form-group">
        <label>{{ "dialogs.moodlePush.courseTitle" | translate }}</label>
        <input
          nbInput
          fullWidth
          [(ngModel)]="targetCourseName"
          placeholder="{{ 'dialogs.moodlePush.courseTitlePlaceholder' | translate }}"
        />
        <p class="hint">{{ "dialogs.moodlePush.courseTitleHint" | translate }}</p>
      </div>

      <div class="form-group">
        <label>{{ "dialogs.moodlePush.shortname" | translate }}</label>
        <input
          nbInput
          fullWidth
          [(ngModel)]="shortname"
          placeholder="{{ 'dialogs.moodlePush.shortnamePlaceholder' | translate }}"
        />
        <p class="hint">{{ "dialogs.moodlePush.shortnameHint" | translate }}</p>
      </div>
    </div>

    <!-- Pushing progress -->
    <div *ngIf="pushing" class="push-progress">
      <nb-spinner status="primary" size="medium"></nb-spinner>
      <p>{{ "dialogs.moodlePush.pushing" | translate }}</p>
    </div>

    <!-- Push result -->
    <div *ngIf="pushResult" class="push-result">
      <nb-icon
        [icon]="pushResult.status === 'partial' ? 'alert-triangle-outline' : 'checkmark-circle-2-outline'"
        [status]="pushResult.status === 'partial' ? 'warning' : 'success'"
      ></nb-icon>
      <p>
        {{
          (pushResult.status === 'partial'
            ? 'dialogs.moodlePush.partialSuccess'
            : 'dialogs.moodlePush.success') | translate
        }}
      </p>
      <p class="result-detail">
        {{ pushResult.processed_items }} / {{ pushResult.total_items }}
        {{ "dialogs.moodlePush.itemsPushed" | translate }}
      </p>
      <div *ngIf="pushResult.warnings?.length" class="warning-list">
        <p *ngFor="let warning of pushResult.warnings">{{ warning }}</p>
      </div>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <div class="footer-actions">
      <button
        type="button"
        nbButton
        status="danger"
        outline
        (click)="close()"
      >
        {{ "buttons.close" | translate }}
      </button>
      <button
        *ngIf="!pushResult"
        nbButton
        status="primary"
        [disabled]="pushing || loading"
        [nbSpinner]="pushing"
        (click)="push()"
      >
        {{ "dialogs.moodlePush.pushButton" | translate }}
      </button>
    </div>
  </nb-card-footer>
</nb-card>
